import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { ICreateDocumentLinkExecutorProps } from './ICreateDocumentLinkExecutorProps';
import { CreateDocumentLinkExecutorModal } from './CreateDocumentLinkExecutorModal';

export const CreateDocumentLinkExecutor = createDocModalExecutor<ICreateDocumentLinkExecutorProps>({
    modal: CreateDocumentLinkExecutorModal,
    defaultModalSize: 'max',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        actionKey: action.key ?? '',
        title: action.options?.title ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
